import { useState } from "react";
import api, { fmtErr } from "../api";
import { toast } from "sonner";
import { PhotoPicker } from "./PhotoPicker";

export const LogWorkRequest = ({ propertyId, onDone, testid = "log-work" }) => {
  const [description, setDescription] = useState("");
  const [photos, setPhotos] = useState([]);
  const [mode, setMode] = useState("next_visit");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!description.trim()) return toast.error("Describe the work");
    setBusy(true);
    try {
      await api.post("/instructions", { property_id: propertyId, description, photos, mode });
      toast.success("Logged — it's on the Add-ons page ready to quote");
      setDescription("");
      setPhotos([]);
      setMode("next_visit");
      onDone?.();
    } catch (e) { toast.error(fmtErr(e)); }
    setBusy(false);
  };

  return (
    <div className="space-y-3" data-testid={`${testid}-form`}>
      <textarea data-testid={`${testid}-description`} className="field-input h-24 w-full py-3" value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Describe the work — e.g. fallen branch cleanup, hedge trim, extra walkway…" />
      <PhotoPicker photos={photos} setPhotos={setPhotos} min={0} testid={`${testid}-photo`} />
      <div className="flex gap-2">
        <button type="button" data-testid={`${testid}-mode-next-visit`} onClick={() => setMode("next_visit")}
          className={`h-12 flex-1 rounded-md border text-sm font-bold transition-colors ${mode === "next_visit" ? "border-primary bg-primary text-primary-foreground" : "border-border"}`}>With the next visit</button>
        <button type="button" data-testid={`${testid}-mode-standalone`} onClick={() => setMode("standalone")}
          className={`h-12 flex-1 rounded-md border text-sm font-bold transition-colors ${mode === "standalone" ? "border-primary bg-primary text-primary-foreground" : "border-border"}`}>Standalone visit</button>
      </div>
      <button type="button" data-testid={`${testid}-submit`} onClick={submit} disabled={busy} className="btn-primary-big !h-14 !text-base disabled:opacity-40">
        {busy ? "Saving…" : "Log work request"}
      </button>
    </div>
  );
};
